<div class="page-header-container">
    <div class="page-title">
        {{'payment.title' | translate}}
        <div class="subtitle-txt text-main fw-medium">
            {{'payment.subtitle' | translate}}:
            <span HJSuppress class="subtitle-value-txt fw-bold text-primary">{{client?.uniqueIdentifier}}</span>
            <button class="btn copy-clipboard-btn ms-2" [cdkCopyToClipboard]="client?.uniqueIdentifier" (click)="showClipboardNotification()">
                <i class="app-icon icon icon-copy icon-md2"></i>
            </button>
        </div>
    </div>
</div>

<div *ngIf="hasData" class="header-buttons-box">
    <button class="btn m-outline-btn" 
        (click)="downloadPayments()" [disabled]="loading"
    >
        <i class="app-icon icon icon-file-excel icon-lg"></i>
        {{'invoice.exportAs' | translate}} {{'invoice.Xls' | translate}}
    </button>
</div>

<div *ngIf="hasData" class="header-buttons-box">
    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
        {{'payment.filter' | translate}}
    </button>
    
    <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
        <div class="btn-group" role="group">
            <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                <span>{{'payment.filterActive' | translate}}</span>
            </button>
            <button class="btn white-btn" (click)="resetFiltersHandler()">
                <span class="active-filters-badge">{{activeFilterCount}}</span>
                <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
            </button>
        </div>
    </div>

    <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
        <div class="btn-group" role="group">
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
                <i class="app-icon icon icon-view-list icon-lg me-2"></i>
                <span>{{'common.listView' | translate }}</span>
            </button>
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
                <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
                <span>{{'common.cardsView' | translate }}</span>
            </button>
        </div>
    </div>
</div>

<div class="d-flex flex-column justify-content-center" *ngIf="!hasData">
    <h3 class="text-center text-secondary my-4">{{'payment.noPayments' | translate}}</h3>
    <no-records-placeholder></no-records-placeholder>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasFilterData">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()"
    ></no-records-placeholder>
</div>

<payment-list-view 
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.LIST_VIEW && windowSizeLgUp) && hasData && hasFilterData"
    [payments]="payments" 
    [props]="props" 
    [navigateToDetailHandler]="navigateToDetailHandler" 
></payment-list-view>
<payment-card-view 
    *ngIf="((tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp) && hasData && hasFilterData )"
    [payments]="payments" 
    [props]="props" 
    [navigateToDetailHandler]="navigateToDetailHandler" 
></payment-card-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>
